import { initializeApp } from "firebase/app";
import { getAuth, RecaptchaVerifier } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfigDev = {
	apiKey: "AIzaSyDXO1_pCDO0pUnYo5FqlNfe7vmaKrAEiPs",
	authDomain: "rushh-6b021.firebaseapp.com",
	projectId: "rushh-6b021",
	storageBucket: "rushh-6b021.firebasestorage.app",
	messagingSenderId: "317069661186",
	appId: "1:317069661186:web:21cc3d9268d5e9cb2bc31b",
	measurementId: "G-B033TYKH7D",
};

const firebaseConfigProd = {
	apiKey: "AIzaSyDBVqSs67GmwRQLqFG6VcaAb4xXIWmEH2k",
	authDomain: "frush-8ca54.firebaseapp.com",
	projectId: "frush-8ca54",
	storageBucket: "frush-8ca54.firebasestorage.app",
	messagingSenderId: "230842945231",
	appId: "1:230842945231:web:a1c0c4757e9fc5a75b31ba",
	measurementId: "G-RQDL1JDFEN",
};
console.log(process.env.REACT_APP_ENVIRONMENT);
const app = initializeApp(process.env.REACT_APP_ENVIRONMENT === "production" ? firebaseConfigProd : firebaseConfigDev);
const auth = getAuth(app);
const db = getFirestore(app);

export { app, auth, db, RecaptchaVerifier };
